function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgButtonAddGroupIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  },
  viewBox: "0 0 25 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.601 9.285c-.371 1.253-1.015 3.221-1.712 4.377l-.618-2.841.15-.512L6.874 10l-.547.309.15.512-.617 2.841c-.689-1.156-1.333-3.132-1.703-4.377-1.121.362-2.674.477-3.23 1.412-.573.962-.838 3.106-.926 4.818a.4.4 0 0 0 .159.344.585.585 0 0 0 .406.141h12.643a.63.63 0 0 0 .406-.141.452.452 0 0 0 .159-.344c-.097-1.712-.353-3.856-.926-4.818-.574-.935-2.127-1.05-3.247-1.412ZM4.192 6.294s.609 2.171 2.682 2.224c2.074-.053 2.683-2.224 2.683-2.224 1.376-1.111.37-2.435.37-2.435V1.697C8.71-.155 6.874.003 6.874.003S5.039-.155 3.821 1.697v2.171s-1.005 1.315.371 2.426Z",
  style: {
    fill: "currentColor",
    fillRule: "nonzero"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.985 10.627c-.384-.656-1.245-.907-2.113-1.126l-3.339 4.995c-.311.471-.821.471-1.133 0l-3.345-4.995c-.868.219-1.729.47-2.114 1.126-.576.974-.848 3.14-.94 4.876a.424.424 0 0 0 .159.351c.112.1.251.146.41.146h12.786a.597.597 0 0 0 .411-.146.424.424 0 0 0 .159-.351c-.093-1.736-.358-3.902-.941-4.876Z",
  style: {
    fill: "currentColor",
    fillRule: "nonzero"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.963 10.581c-1.517 0-2.491-.623-2.491-1.047h-.443c0 1.087 1.477 1.656 2.928 1.656 1.451 0 2.928-.569 2.928-1.656h-.444c.013.424-.96 1.047-2.478 1.047ZM13.909 7.904h2.756a4.627 4.627 0 0 1-1.186-3.332c.007-.086.014-.179.067-.245.046-.06.112-.1.185-.139.517-.272 1.034-.544 1.557-.815.252.662.868 1.126 1.537 1.365.662.238 1.384.278 2.087.318a6.75 6.75 0 0 1-1.239 2.848c.801 0 1.603-.006 2.398-.006 0-1.524.007-3.041.007-4.565 0-.245 0-.497-.06-.735-.079-.318-.258-.61-.464-.868A4.65 4.65 0 0 0 18.255.007c-1.106-.066-2.544.312-3.312 1.166-.809.901-1.067 2.18-1.067 3.359-.013 1.133.159 2.259.033 3.372Z",
  style: {
    fill: "currentColor",
    fillRule: "nonzero"
  }
}));
export default SvgButtonAddGroupIcon;